import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LevelMap.css'; // Reuse styles for consistency

const HowToPlay = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

return (
  <div
    className="level-map-container"
    style={{
      background: '#f9f4e8',
      paddingTop: '20px',
      paddingBottom: '60px',
      fontFamily: 'Arial, sans-serif'
    }}
  >
    <button onClick={handleBack} className="back-button">← Back</button>

    {/* Move the title up here in flow */}
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <h1
        style={{
          fontFamily: 'Bangers, cursive',
          fontSize: '2.5rem',
          color: '#d62828',
          textShadow: '2px 2px white, 4px 4px pink',
          marginBottom: '20px',
        }}
      >
        HOW TO PLAY
      </h1>
    </div>

    <div
      style={{
        maxWidth: '700px',
        margin: '0 auto 40px',
        background: 'rgba(255,255,255,0.9)',
        padding: '20px',
        borderRadius: '12px',
        lineHeight: '1.7',
        color: '#333',
        boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
      }}
    >
      <p>This is a fun game that helps you learn math by solving real-life challenges!</p>

      <h3>🍎 Task 1: Adding Fruits</h3>
      <ul>
        <li>Look at how many fruits you already have.</li>
        <li>See how many are being added.</li>
        <li>Use your fingers or count out loud if you want!</li>
        <li>Select the right total from the choices.</li>
      </ul>

      <h3>💰 Task 2: Making Payments</h3>
      <ul>
        <li>Read the price (e.g., €7).</li>
        <li>Pick money notes that add up to the total (like €5 + €2).</li>
        <li>Press <strong>"Make Payment"</strong> when you're ready.</li>
      </ul>

      <h3>✨ Tips to Win</h3>
      <ul>
        <li>Go level by level and unlock the whole map!</li>
        <li>If you make a mistake, don’t worry — you’ll get helpful hints 😊</li>
        <li>Use pictures, count carefully, and have fun!</li>
      </ul>

      <p>
        Learning math can be awesome when it's part of a game.
        You're not just solving problems — you're becoming a checkout champion!
      </p>
    </div>
  </div>
);

};

export default HowToPlay;
